type CurrentUser = {
    isTrial?: boolean,
    isCoach?: boolean,
    isBasic?: boolean,
    numDaysRemainingInTrial?: ?number,
    trialEndsAt?: ?string,
    subscriptionPlan?: ?string,
    roleList?: Array<string>
};

export type UserTraits = {
    isTrial?: boolean,
    isCoach?: boolean,
    isBasic?: boolean,
    trialDaysRemaining?: number | null,
    trialEndsAt?: string | null,
    subscriptionPlan?: string | null,
    roleList?: Array<string>
};

export const buildUserTraits = (user: CurrentUser = {}): UserTraits => {
    const traits: UserTraits = {};

    if (typeof user.isTrial === 'boolean') traits.isTrial = user.isTrial;
    if (typeof user.isCoach === 'boolean') traits.isCoach = user.isCoach;
    if (typeof user.isBasic === 'boolean') traits.isBasic = user.isBasic;

    if (user.numDaysRemainingInTrial !== undefined) {
        const raw = user.numDaysRemainingInTrial;
        // `-1` is a legacy API sentinel for "basic coach, no trial" -> null.
        traits.trialDaysRemaining =
            typeof raw === 'number' && Number.isFinite(raw) && raw !== -1
                ? raw
                : null;
    }

    if (user.trialEndsAt !== undefined) {
        traits.trialEndsAt =
            typeof user.trialEndsAt === 'string' ? user.trialEndsAt : null;
    }

    if (user.subscriptionPlan !== undefined) {
        traits.subscriptionPlan =
            typeof user.subscriptionPlan === 'string'
                ? user.subscriptionPlan
                : null;
    }

    if (user.roleList !== undefined) {
        traits.roleList = Array.isArray(user.roleList)
            ? user.roleList.slice()
            : [];
    }

    return traits;
};

export default buildUserTraits;
